<template>
	<sf-modal-layout size="xxl" :title="title" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<user-email-pop-search-view ref="userEmailPopSearchView" :scrId="scrId" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<user-email-pop-view ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="() => close()">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/UserEmailPopup/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';

import UserEmailPopSearchView from './Content/Search/UserEmailPopSearchView.vue';
import UserEmailPopView from './Content/Table/UserEmailPopView.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		userName: { type: String, default: '' },
		userGbn: { type: String, default: '' }
	},
	components: { UserEmailPopSearchView, UserEmailPopView },
	data() {
		return {
			show: false,
			title: '사용자 조회',
			propUserName: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			try {
				this.show = true;
				if (param) {
					this.propUserName = param.userName;
					this.setSearchParam_({ key: 'userId', value: param.userId });
					this.setSearchParam_({ key: 'userName', value: param.userName });
					this.setSearchParam_({ key: 'userGbn', value: param.userGbn });
				}
				this.reload();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		close() {
			// debugger;
			this.setSearchParam_({ key: 'userId', value: '' });
			this.setSearchParam_({ key: 'userName', value: '' });
			this.setSearchParam_({ key: 'userGbn', value: '' });

			this.$refs.userEmailPopSearchView.reset();
			this.show = false;
		},
		reload(currentPage = 1, pageUnit = 10) {
			if (this.$refs.userEmailPopSearchView) {
				this.$refs.userEmailPopSearchView.searchList(currentPage, pageUnit);
			}
		},
		// userGbn은 하나의 Form에 사용자 찾기가 2건이 필요할 경우 해당 값을 셋팅한다.
		sendData(sendParam, userGbn) {
			this.$emit('SendData', sendParam, userGbn);
			this.close();
		}
	}
};
</script>

<style></style>
